import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import Portfolio from "../pages/portfolio/page";
import Info from "../pages/info/page";
import Estimate from "../pages/estimate/page";
import Consultation from "../pages/consultation/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <Services /> },
  { path: "/portfolio", element: <Portfolio /> },
  { path: "/info", element: <Info /> },
  { path: "/estimate", element: <Estimate /> },
  { path: "/consultation", element: <Consultation /> },
  { path: "/contact", element: <Contact /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
